import { render, staticRenderFns } from "./SystemEdit.vue?vue&type=template&id=d0486c20&scoped=true"
import script from "./SystemEdit.vue?vue&type=script&lang=js"
export * from "./SystemEdit.vue?vue&type=script&lang=js"
import style0 from "./SystemEdit.vue?vue&type=style&index=0&id=d0486c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0486c20",
  null
  
)

export default component.exports